"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Company;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const Helper_1 = require("../Helper");
const Screen_1 = __importDefault(require("../components/Screen"));
const Card_1 = __importDefault(require("../components/Card"));
const Button_1 = __importDefault(require("../components/Button"));
const AppMenuList_1 = __importDefault(require("../components/AppMenuList"));
const MasonryList_1 = __importDefault(require("../components/MasonryList"));
const react_i18next_1 = require("react-i18next");
const SingleSignOn_1 = require("../shared/SingleSignOn");
const BenefitRenewalCard_1 = __importDefault(require("../partials/BenefitRenewalCard"));
const PtoApprovalsCard_1 = __importDefault(require("../partials/PtoApprovalsCard"));
const CompanyMyApprovalsCard_1 = __importDefault(require("../partials/CompanyMyApprovalsCard"));
const UserContext_1 = require("../contexts/UserContext");
const native_1 = require("@react-navigation/native");
const CompanyOnboardingNotice_1 = __importDefault(require("../partials/CompanyOnboardingNotice"));
const RiskAndComplianceCard_1 = __importDefault(require("../partials/RiskAndComplianceCard"));
const EmployeeManagementCard_1 = __importDefault(require("../partials/EmployeeManagementCard"));
const FirebaseAnalytics_1 = __importDefault(require("../shared/FirebaseAnalytics"));
const CompanyCalendarCard_1 = __importDefault(require("../partials/CompanyCalendarCard"));
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const PrehiresListCard_1 = __importDefault(require("../partials/PrehiresListCard"));
const CompanyUpcomingDatesCard_1 = __importDefault(require("../partials/CompanyUpcomingDatesCard"));
const ReferralsCard_1 = __importDefault(require("../partials/ReferralsCard"));
const ElevatePermissions_1 = __importDefault(require("../ElevatePermissions"));
const CompanyContent = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size, columns } = (0, ResponsiveContext_1.useResponsiveContext)();
    const [benefitRenewal] = react_1.default.useState(userContext.client?.features?.find((feature) => feature.name === 'benefit-renewal'));
    const [riskAndCompliance] = react_1.default.useState(userContext.client?.features?.find((feature) => feature.name === 'wc-risk'));
    const benefitRenewalDisabled = benefitRenewal == null || !benefitRenewal?.isEnabled;
    const riskAndComplianceDisabled = riskAndCompliance == null || !riskAndCompliance?.isEnabled;
    const [companyOnboardingFeature] = react_1.default.useState(userContext.client?.features?.find((feature) => feature.name === 'company-onboarding'));
    const companyOnboardingDisabled = companyOnboardingFeature == null || !companyOnboardingFeature?.isEnabled;
    const timeAndAttendance = userContext.client?.features?.find((feature) => feature.name === 'time-and-attendance');
    const taVendor = timeAndAttendance?.vendor?.toLowerCase();
    const canSeeTimeAndAttendanceLink = !!userContext.isAdmin && !userContext.isImpersonated && !!timeAndAttendance?.isEnabled && (taVendor === 'kronos' || taVendor === 'timeco');
    const [pendingCompanyAdmin, setPendingCompanyAdmin] = react_1.default.useState(null);
    const openTimeAndAttendance = () => {
        if (userContext.isImpersonated)
            return;
        Helper_1.Helper.verifyLocationPermissions().then(() => {
            if (taVendor !== 'kronos' && taVendor !== 'timeco')
                return;
            const provider = taVendor;
            FirebaseAnalytics_1.default.LogEvent('feature_used', {
                feature: provider === 'kronos' ? 'Kronos SSO' : 'TimeCo SSO',
                client: userContext.client?.id,
                employee: userContext.employee?.employeeId
            });
            SingleSignOn_1.SingleSignOn.Perform({
                navigation: props.navigation,
                client: userContext?.client?.id,
                provider,
                title: 'Time and Attendance',
                forceMobileWeb: Helper_1.Helper.isPlatformWeb
            });
        });
    };
    const openCompanyAdmin = (useComponentId = false) => {
        FirebaseAnalytics_1.default.LogEvent('feature_used', {
            'feature': 'Prism SSO - Company Admin',
            'client': userContext.client?.id,
            'employee': userContext.employee?.employeeId
        });
        SingleSignOn_1.SingleSignOn.Perform({
            navigation: props.navigation,
            client: userContext?.client?.id,
            provider: 'prismfeature',
            title: t('common:appmenus.companyAdmin'),
            ...(useComponentId ? { additionalRouting: 'HRPY.WORK*WORKSITE.TIME.ENTRY' } : {}),
        });
    };
    react_1.default.useEffect(() => {
        if (props.route.params?.action !== 'companyadmin')
            return;
        const clientFromRoute = props.route.params?.client;
        const isValidClient = clientFromRoute && userContext.clientList?.some(c => c.id === clientFromRoute) && clientFromRoute === userContext.client?.id;
        if (!isValidClient) {
            FirebaseAnalytics_1.default.LogEvent('company_admin_sso_client_mismatch', {
                clientInRoute: clientFromRoute,
                currentClient: userContext.client?.id,
                clientList: userContext.clientList?.map(c => c.id),
            });
            return;
        }
        setPendingCompanyAdmin({ clientId: clientFromRoute });
    }, [props.route.params?.action, props.route.params?.client]);
    react_1.default.useEffect(() => {
        if (pendingCompanyAdmin) {
            openCompanyAdmin(true);
            setPendingCompanyAdmin(null);
            props.navigation.setParams({ action: undefined, client: undefined });
        }
    }, [pendingCompanyAdmin]);
    const cardMargin = (size == 'sm' ? 8 : 16);
    const portalEnabled = userContext?.adminExperience == 'both' ||
        userContext?.adminExperience == 'elevate-edge';
    return ((0, jsx_runtime_1.jsx)(react_native_1.View, { children: (0, jsx_runtime_1.jsxs)(MasonryList_1.default, { style: {
                margin: (portalEnabled ? (columns > 1 ? cardMargin : 0) : (columns > 1 ? -cardMargin : 0)),
                marginTop: (portalEnabled ? (columns > 1 ? cardMargin : 0) : cardMargin)
            }, children: [!companyOnboardingDisabled &&
                    (0, jsx_runtime_1.jsx)(CompanyOnboardingNotice_1.default, { navigation: props.navigation }), !benefitRenewalDisabled &&
                    (0, jsx_runtime_1.jsx)(BenefitRenewalCard_1.default, { navigation: props.navigation }), userContext?.adminExperience == 'prism-core' &&
                    (0, jsx_runtime_1.jsx)(Card_1.default, { style: { padding: 0 }, children: (0, jsx_runtime_1.jsxs)(AppMenuList_1.default, { children: [(0, jsx_runtime_1.jsx)(AppMenuList_1.default.Item, { name: t('common:appmenus.companyAdmin'), color: THEME.Text, actionIcon: Theme_1.ICONS.Regular.ArrowUpRightFromSquare, onPress: () => { openCompanyAdmin(); } }), canSeeTimeAndAttendanceLink && ((0, jsx_runtime_1.jsx)(AppMenuList_1.default.Item, { name: t('common:appmenus.timeAttendance'), color: THEME.Text, actionIcon: Theme_1.ICONS.Regular.ArrowUpRightFromSquare, onPress: openTimeAndAttendance })), (0, jsx_runtime_1.jsx)(AppMenuList_1.default.Item, { name: t('common:appmenus.companySettings'), color: THEME.Text, actionIcon: Theme_1.ICONS.Regular.Gear, onPress: () => props.navigation.navigate('CompanySettings') })] }) }), userContext?.adminExperience == 'prism-core' &&
                    (0, jsx_runtime_1.jsx)(PtoApprovalsCard_1.default, { navigation: props.navigation }), ['elevate-edge', 'both'].includes(userContext?.adminExperience) &&
                    (0, jsx_runtime_1.jsx)(CompanyMyApprovalsCard_1.default, { navigation: props.navigation }), ['elevate-edge', 'both'].includes(userContext?.adminExperience) &&
                    (0, jsx_runtime_1.jsx)(PrehiresListCard_1.default, { navigation: props.navigation, hireButton: (userContext.permissions?.includes(ElevatePermissions_1.default.Hire) &&
                            (0, jsx_runtime_1.jsxs)(Button_1.default, { type: 'outline', accessibilityHint: t('employees:hints.employeeAdd'), onPress: () => {
                                    FirebaseAnalytics_1.default.LogEvent('feature_used', {
                                        'feature': "Hire Employee",
                                        'client': userContext.client?.id,
                                        'employee': userContext.employee?.employeeId
                                    });
                                    props.navigation.navigate('AddEmployee');
                                }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Primary, fontSize: 14, fontWeight: '500', marginHorizontal: 6 }, children: t('profile:labels.hire') }), (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: THEME.Primary, icon: Theme_1.ICONS.Regular.Plus, size: 14, style: { marginRight: 6 } })] })) }), userContext?.adminExperience == 'prism-core' &&
                    (0, jsx_runtime_1.jsx)(EmployeeManagementCard_1.default, { navigation: props.navigation }), (0, jsx_runtime_1.jsx)(CompanyCalendarCard_1.default, { navigation: props.navigation }), ['elevate-edge', 'both'].includes(userContext?.adminExperience) &&
                    (0, jsx_runtime_1.jsx)(CompanyUpcomingDatesCard_1.default, { navigation: props.navigation }), !riskAndComplianceDisabled &&
                    (0, jsx_runtime_1.jsx)(RiskAndComplianceCard_1.default, { navigation: props.navigation }), (0, jsx_runtime_1.jsx)(ReferralsCard_1.default, { navigation: props.navigation })] }) }, props.refreshKey));
};
function Company(props) {
    const THEME = (0, ThemeContext_1.useTheme)();
    const [refreshKey, setRefreshKey] = react_1.default.useState(0);
    const navigation = react_1.default.useContext(native_1.NavigationContext);
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size, columns } = (0, ResponsiveContext_1.useResponsiveContext)();
    const onRefresh = react_1.default.useCallback(() => {
        setRefreshKey(Math.random());
    }, []);
    const portalEnabled = userContext?.adminExperience == 'both' ||
        userContext?.adminExperience == 'elevate-edge';
    return ((0, jsx_runtime_1.jsxs)(Screen_1.default, { containerStyle: (() => {
            if (portalEnabled && columns > 1)
                return {
                    backgroundColor: THEME.CardBackground, padding: 0
                };
            if (columns == 1)
                return {
                    padding: 0
                };
            return null;
        })(), scrollStyle: (() => {
            if (portalEnabled && columns > 1)
                return {
                    backgroundColor: THEME.CardBackground
                };
            return null;
        })(), onRefresh: onRefresh, children: [!portalEnabled &&
                (0, jsx_runtime_1.jsx)(react_native_1.Image, { resizeMode: 'cover', source: size != 'sm' ? Theme_1.IMAGES.CompanyBackgroundWeb : Theme_1.IMAGES.CompanyBackground, style: { width: '100%', height: 'auto', aspectRatio: size != 'sm' ? 11.2 : 5.6, marginTop: size != 'sm' ? 12 : 4, borderRadius: size != 'sm' ? 4 : 0 } }), (0, jsx_runtime_1.jsx)(CompanyContent, { navigation: navigation, route: props.route, refreshKey: refreshKey })] }));
}
